/**
 * created by li si yi
 * 用户操作日志
 */
import React, {Component} from 'react';
import {Input, Select, Button, DatePicker, Pagination, Modal} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import moment from "moment";
import $Jq from 'jquery'

const {RangePicker} = DatePicker;
const {Search} = Input;
const {Option} = Select;
export default class VisitLog extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            count: 0,
            everyList: [],
            visible: false,
            modalData: '',//弹窗数据
            columns: [
                {
                    title: '用户Id',
                    dataIndex: 'userId',
                    ellipsis: true,
                    width: '200px',
                    key: 'userId',
                    render: (text, record) => {
                        return (
                            <span style={{cursor: 'pointer'}}
                                  onClick={() => this.modalItem(record)}>{text ? text : ""}</span>
                        )
                    }
                },
                {
                    title: '请求时间',
                    dataIndex: 'timestamp',
                    key: 'timestamp',
                    width: '180px',
                    ellipsis: true,
                    render: (text) => {
                        let time = new Date(text * 1000);
                        return (
                            <div>
                                <div>{time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
                            </div>
                        )
                    }
                },
                // {
                //     title: 'sessionId',
                //     dataIndex: 'session',
                //     ellipsis: true,
                //     width: '180px',
                //     key: 'session',
                //     render: (text) => {
                //         return (
                //             <div>
                //                 {text ? text : ""}
                //             </div>
                //         )
                //     }
                // },
                {
                    title: '请求地址',
                    dataIndex: 'path',
                    key: 'path',
                    width: 250,
                    ellipsis: true,
                    render: (text) => {
                        return (
                            <span>{text ? text : ""}</span>
                        )
                    }
                },
                {
                    title: '响应时长',
                    dataIndex: 'timeTaken',
                    key: 'timeTaken',
                    width: 100,
                    ellipsis: true,
                    render: (text) => {
                        return (
                            <span>{text}ms</span>
                        )
                    }
                },
            ],
            startTime: null,
            endTime: null,
            params: {
                start: 1,//分页
                size: 10,
                userId: "",
                startTime: null,//开始时间
                endTime: null,//结束时间
                path: '',
            },
            dataSource: [],//列表数据
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDataSource();
    }

    // 日期
    getList(date) {
        let {params} = this.state;
        params.startTime = date[0];
        params.endTime = date[1];
        let startTime = params.startTime ? new Date(params.startTime.format('YYYY-MM-DD') + ' 00:00:00').getTime() : null;//YYYY-MM-DD HH:mm:ss
        let endTime = params.endTime ? new Date(params.endTime.format('YYYY-MM-DD') + ' 23:59:59').getTime() : null;
        this.setState({
            params: {
                ...this.state.params,
                startTime: startTime,
                endTime: endTime,
            }
        }, () => {
            this.getDataSource();
        });

    }

    render() {
        return (
            <div style={{margin: "15px"}}>
                <div style={{
                    backgroundColor: "#fff",
                    width: "100%",
                    maxHeight: 'calc(100vh - 100px)',
                    borderRadius: '5px',
                    paddingTop: 24
                }}>
                    <div style={{padding: '0px 32px 24px'}}>
                        {this.renderHead()}
                    </div>
                    {this.renderContent()}
                </div>
            </div>
        )
    }

    renderHead() {
        return (
            <div style={{display: 'flex'}}>
                <div style={{marginLeft: 0}}><Search
                    placeholder="请输入用户Id"
                    value={this.state.params.userId}
                    onChange={(e) => {
                        this.setState({
                            params: {
                                ...this.state.params,
                                userId: e.target.value
                            }
                        })
                    }}
                    onSearch={value => this.onSearch()}
                    style={{width: 200}}
                /></div>
                <div style={{marginLeft: 20}}>
                    <Search
                        placeholder="请输入请求地址"
                        value={this.state.params.path}
                        onChange={(e) => {
                            this.setState({
                                params: {
                                    ...this.state.params,
                                    path: e.target.value
                                }
                            })
                        }}
                        onSearch={value => this.onSearch()}
                        style={{width: 200}}
                    />
                </div>
                {/*<div style={{marginLeft: 20}}>*/}
                {/*    <Search*/}
                {/*        placeholder="请输入ip地址"*/}
                {/*        value={this.state.params.ip}*/}
                {/*        onChange={(e) => {*/}
                {/*            this.setState({*/}
                {/*                params: {*/}
                {/*                    ...this.state.params,*/}
                {/*                    ip: e.target.value*/}
                {/*                }*/}
                {/*            })*/}
                {/*        }}*/}
                {/*        onSearch={value => this.onSearch()}*/}
                {/*        style={{width: 200}}*/}
                {/*    />*/}
                {/*</div>*/}
                <div style={{marginLeft: 20}} onClick={()=>{
                    $Jq('.picker').find('.ant-calendar-input').attr('disabled','disabled');
                    // $Jq('.picker').find('.ant-calendar-input').keydown(function (event) {
                    //     event = event ? event : window.event;
                    //     if (event.keyCode) {
                    //         return false;
                    //     }
                    // });
                }}>
                    <RangePicker
                        className={'picker'}
                        getCalendarContainer={triggerNode => triggerNode.parentNode}
                        value={[this.state.startTime, this.state.endTime]}
                        format={"YYYY-MM-DD"}
                        onChange={(date, dateString) => {
                            this.state.startTime = date[0];
                            this.state.endTime = date[1];
                            this.getList(date);
                        }}/>
                </div>
                <Button style={{marginLeft: 20}} type="primary" onClick={() => this.revert()}>重置</Button>
            </div>
        )
    }

    renderContent() {
        return (
            <div>
                <div className={'tableNullStyle'} style={{maxHeight: 'calc(100vh - 246px)', padding: '0px 32px'}}>
                    <Scrollbars autoHeight autoHeightMax={'calc(100vh - 246px)'}>
                        <BaseTable
                            rowKey="id"
                            dataSource={this.state.dataSource}
                            columns={this.state.columns}
                            pagination={false}
                        />
                    </Scrollbars>
                    <style>{`
                            .tableNullStyle .ant-table-placeholder{
                               display:flex;
                               justify-content: center;
                               align-items: center;
                               height:500px;
                               border-bottom:none;
                            }
                        `}</style>
                </div>
                {this.state.dataSource.length ? this.renderFooter() : null}
                {/*详情弹窗*/}
                {this.renderModal()}
            </div>
        )
    }

    // 分页
    renderFooter = () => {
        let {params, count} = this.state;
        // 获取当前tab参数
        let {start, size} = params;
        return (
            <div className={'pagination'} style={{paddingTop: "17px", paddingBottom: "17px"}}>
                <div style={{padding: "0 10px 0"}}>共{count}条数据</div>
                <Pagination
                    showSizeChanger
                    current={start}
                    pageSize={size}
                    total={count}
                    showQuickJumper={true}
                    onChange={(page, size) => this.pageChange(page, size)}
                    onShowSizeChange={(page, size) => this.pageChange(page, size)}
                />
            </div>
        )
    };

    // 弹出
    modalItem = (record) => {
        // console.log(record);
        this.setState({visible: true});
        this.state.dataSource.forEach(item => {
            if (record.id === item.id) {
                this.state.modalData = JSON.stringify(item);
            }
        });
    };

    // 详情弹窗
    renderModal = () => {
        return (
            <Modal
                title="日志详情"
                width={800}
                visible={this.state.visible}
                maskClosable={false}   //点击蒙层是否允许关闭
                onCancel={this.handleCancel}
                footer={null}
                // destroyOnClose={true}
            >
                <div>{this.state.modalData}</div>
            </Modal>
        )
    };

    // 取消
    handleCancel = () => {
        this.setState({
            visible: false
        })
    };
    //获取列表数据
    getDataSource = () => {
        let params = {
            "fieldQuery": {},
            "page": {
                "size": this.state.params.size,
                "start": this.state.params.start,
            }
        };
        let bodyVal = {
            "queryList": [
                {
                    fieldQuery: {
                        queryRelationTypeEnum: "OR",
                        queryList: [
                            {
                                "queryTypeEnum": "LIKE",
                                "fieldName": "userId",
                                "value": this.state.params.userId,
                                "valueTypeEnum": "STRING"
                            },
                            {
                                "queryTypeEnum": "LIKE",
                                "fieldName": "path",
                                "value": this.state.params.path,
                                "valueTypeEnum": "STRING"
                            },
                        ]
                    }
                },
                {
                    "queryTypeEnum": "RANGE",
                    "fieldName": "createTime",
                    "min": this.state.params.startTime,
                    "max": this.state.params.endTime,
                    "valueTypeEnum": "LONG"
                }
            ],
            "page": {
                "size": this.state.params.size,
                "start": this.state.params.start,
            }
        };
        let flag = 0;
        bodyVal.queryList.forEach(item => {
            if (item && item.fieldQuery && item.fieldQuery.queryList) {
                item.fieldQuery.queryList.forEach(Item => {
                    if (Item.value) {
                        flag += 1;
                    }
                });
            }

            if (item.value || (item.min && item.max)) {
                flag += 1;
            }
        });
        if (flag > 0) {
            params = {
                "fieldQuery": {
                    "valueTypeEnum": "STRING",
                    "queryRelationTypeEnum": "AND",
                    "queryList": [],
                },
                "page": {
                    "size": this.state.params.size,
                    "start": this.state.params.start,
                }
            };

            bodyVal.queryList.forEach(item => {
                // console.log(item, item.value);
                if (item && item.fieldQuery && item.fieldQuery.queryList) {
                    item.fieldQuery.queryList.forEach(Item => {
                        if (Item.value) {
                            params.fieldQuery.queryList.push(Item);
                        }
                    });
                }
                if (item.value || (item.min && item.max)) {
                    params.fieldQuery.queryList.push(item)
                }
            });
        }
        this.request({
            url: '/cm-sites-sys/weblog/find',
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                let dataSource = [];
                let count = 0;
                if (res) {
                    dataSource = res.data;
                    count = res.count;
                }
                this.setState({dataSource, count})
            }
        })
    };

    //分页改变
    pageChange(page, size) {
        this.setState({
            params: {
                ...this.state.params,
                start: page,
                size: size
            }
        }, () => {
            this.getDataSource();
        });
    }

    // 搜索
    onSearch() {
        this.state.params.start = 1;
        this.getDataSource();
    }

    //重置按钮
    revert() {
        this.setState({
            startTime: null,//开始时间
            endTime: null,//结束时间
            params: {
                start: 1,//分页
                size: 10,
                userId: "",
                startTime: null,//开始时间
                endTime: null,//结束时间
            }
        }, () => {
            this.getDataSource()
        });
    }
}